// src/components/MultiSelectUsers.js

import React, { useState, useEffect } from "react";
import { Drawer, Input, Button, List } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { fetchTeamsRequest } from "../redux-saga/actions/userActions";

const MultiSelectUsers = ({ visible, onClose, predefinedAssignees = [] }) => {
  const dispatch = useDispatch();
  const { data: users, loading } = useSelector((state) => state.user);
  const [currentSelecteduser,setCurrentSelecteduser]=useState([])

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    if (visible) {
      dispatch(fetchTeamsRequest());
    }
  }, [visible, dispatch]);

  useEffect(() => {
    if (visible && users.data.length > 0) {
      console.log("predefinedAssignees", users);
      setSelectedUsers(predefinedAssignees);
    }
    console.log("predefinedAssignees", users);
  }, [predefinedAssignees, visible, users]);

  const filteredUsers = users.data.filter((user) =>
    user.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelectUser = (id) => {
    setSelectedUsers((prev) =>
      prev.includes(id) ? prev.filter((userId) => userId !== id) : [...prev, id]
    );
  };

  const handleAddAssignees = () => {
    onClose(currentSelecteduser);
  };

  return (
    <Drawer
      title="Assignee"
      placement="right"
      visible={visible}
      onClose={() => onClose(predefinedAssignees)}
      footer={
        <div style={{ textAlign: "right" }}>
          <Button style={{ marginRight: 8 }} onClick={() => onClose(predefinedAssignees)}>
            Cancel
          </Button>
          <Button type="primary" onClick={handleAddAssignees}>
            Save
          </Button>
        </div>
      }
    >
      <Input
        placeholder="Search User"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ marginBottom: 10 }}
      />
      {loading ? (
        <p>Loading...</p>
      ) : (
        <List
          dataSource={filteredUsers}
          renderItem={(user) => (
            !selectedUsers.includes(user.id)?(    <List.Item
              key={user.id}
              onClick={() => setCurrentSelecteduser([...currentSelecteduser,user.id])}
              style={{
                cursor: "pointer",
                backgroundColor: currentSelecteduser?.includes(user.id) ? "#e6f7ff" : "transparent",
                padding: "10px",
                borderRadius: "4px",
                margin: "4px 0",
              }}
            >
              {user.name}
            </List.Item>):null
        
          )}
        />
      )}
    </Drawer>
  );
};

export default MultiSelectUsers;
